import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {RetentionWarningModel} from '../../api/models/retention-warning-model';
import {AccountService} from '../account.service';
import {RecordingsPlanModel} from '../../api/models/recordings-plan-model';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

export interface StorageRetentionDialogData {
  recordingsPlan: RecordingsPlanModel;
}

@Component({
    selector: 'app-storage-retention-dialog',
    template: `
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
      <div fxFlex>Change Recordings Retention Limits?</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
    <mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
      <h3 *ngIf="isSupportAccess" style="margin: 5px; text-align: center;">Are you sure you want change recording retention limits?</h3>
      <h3 *ngIf="!isSupportAccess" style="margin: 5px; text-align: center;">Would you like to request to change your retention limits?</h3>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button [mat-dialog-close]="false">Close</button>
      <button mat-stroked-button color="primary" *ngIf="isSupportAccess" [mat-dialog-close]="true">Confirm</button>
      <button mat-stroked-button color="primary" *ngIf="!isSupportAccess" [mat-dialog-close]="true" cdkFocusInitial>Request</button>
    </mat-dialog-actions>
  `,
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        MatDialogActions,
        MatButton,
    ],
})
export class StorageRetentionDialogComponent implements OnInit, OnDestroy {

  isSupportAccess = false;

  constructor(public dialogRef: MatDialogRef<StorageRetentionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: StorageRetentionDialogData,
              private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.isSupportAccess = this.authService.hasAccess([RolesEnum.Support])
  }

  ngOnDestroy() {
  }
}
